import React from 'react';
import { Palette, Heart, ArrowRight, Mail, Github, Linkedin, Instagram } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import GraphicDesignAboutMe from '../GraphicAbout/GraphicDesignAboutMe';
import profileImage from '../../images/webdesign-hero.mp4';
import styles from './GraphicDesignHero.module.css';

const GraphicDesignHero = ({ mousePosition }) => {
  const navigate = useNavigate();

  const handleExploreWork = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleConnect = () => {
    navigate('/contact');
  };

  return (
    <>
      {/* Hero Section */}
      <section className={styles.hero}>
        {/* Animated Background Elements */}
        <div className={styles.bgElements}>
          <div className={styles.blob1} style={{ transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)` }}></div>
          <div className={styles.blob2} style={{ transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)` }}></div>
          <div className={styles.blob3}></div>
        </div>

        {/* Mesh Gradient Overlay */}
        <div className={styles.meshGradient}></div>

        {/* Floating Shapes */}
        <div className={styles.floatingShapes}>
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`${styles.shape} ${styles[`shape${i + 1}`]}`}></div>
          ))}
        </div>

        <div className={styles.heroContent}>
          <div className={styles.heroGrid}>
            {/* Left Side - Text Content */}
            <div className={styles.heroText}>
              <div className={styles.badge}>
                <Palette size={18} className={styles.badgeIcon} />
                <span>Visual Storyteller</span>
              </div>

              <h1 className={styles.heroTitle}>
                <span className={styles.titleLine1}>Creating</span>
                <span className={styles.titleLine2}>Visual Magic</span>
                <span className={styles.titleLine3}>That Speaks</span>
              </h1>

              <p className={styles.heroSubtitle}>
                Transforming ideas into captivating visual experiences through
                illustration, graphic design, and creative storytelling.
              </p>

              <div className={styles.heroCta}>
                <button className={styles.primaryBtn} onClick={handleExploreWork}>
                  <span className={styles.btnText}>Explore My Work</span>
                  <ArrowRight size={20} />
                </button>
                <button className={styles.secondaryBtn} onClick={handleConnect}>
                  <Mail size={18} />
                  <span>Let's Connect</span>
                </button>
              </div>

              {/* Social Links */}
              <div className={styles.socialLinks}>
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}><Github size={20} /></a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}><Instagram size={20} /></a>
                <a href="https://behance.net" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14H15.97c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"/>
                  </svg>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}><Linkedin size={20} /></a>
              </div>
            </div>

            {/* Right Side - Profile Image Showcase */}
            <div className={styles.heroVisual}>
              <div className={styles.gifContainer}>
                <video
                  src={profileImage}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className={styles.profileImage}
                />

                {/* Decorative Frame */}
                <div className={styles.gifFrame}></div>
                <div className={styles.gifGlow}></div>
              </div>

              {/* Floating Stats */}
              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap', marginTop: '1rem' }}>
                <div className={styles.statCard1}>
                  <div className={styles.statNumber}>50+</div>
                  <div className={styles.statLabel}>Projects</div>
                </div>
                <div className={styles.statCard2}>
                  <Heart size={20} className={styles.heartIcon} />
                  <div className={styles.statNumber}>100%</div>
                  <div className={styles.statLabel}>Passion</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className={styles.scrollIndicator}>
          <div className={styles.scrollWheel}>
            <div className={styles.scrollDot}></div>
          </div>
          <span className={styles.scrollText}>Scroll to explore</span>
        </div>
      </section>

      {/* About Me Section */}
      <GraphicDesignAboutMe />


    </>
  );
};

export default GraphicDesignHero;